import { render } from "./callsNumber.vue?vue&type=template&id=1639c857&scoped=true"
import script from "./callsNumber.vue?vue&type=script&lang=js"
export * from "./callsNumber.vue?vue&type=script&lang=js"

import "./callsNumber.vue?vue&type=style&index=0&id=1639c857&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1639c857"

export default script